// frontend/src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Permission шалгах helper функцүүд
const hasPermission = (user, permission) => {
  if (!user || !Array.isArray(user.perms)) return false;
  
  // ✅ SYSTEM ADMIN БОЛ БҮХ ЭРХТЭЙ
  if (user.role === 'system_admin') return true;
  
  return user.perms.includes(permission);
};

const hasAnyPermission = (user, permissions) => {
  if (!user || !Array.isArray(user.perms)) return false;
  
  // ✅ SYSTEM ADMIN БОЛ БҮХ ЭРХТЭЙ
  if (user.role === 'system_admin') return true;
  
  return permissions.some(perm => user.perms.includes(perm));
};

const hasRole = (user, roles) => {
  if (!user || !user.role) return false;
  return Array.isArray(roles) ? roles.includes(user.role) : user.role === roles;
};

const ProtectedRoute = ({ 
  children, 
  requiredPermission,
  requiredPermissions,
  requireAll = false,
  requiredRole,
  fallbackPath = '/admin/dashboard' 
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Ачааллаж байна...</p>
        </div>
      </div>
    );
  }

  // ✅ SYSTEM ADMIN БОЛ БҮГДИЙГ НЭЭХ
  if (user?.role === 'system_admin') {
    return children;
  }

  // Role шалгах
  if (requiredRole && !hasRole(user, requiredRole)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Нэг эрх шалгах
  if (requiredPermission && !hasPermission(user, requiredPermission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Олон эрх шалгах
  if (requiredPermissions && requiredPermissions.length > 0) {
    const hasAccess = requireAll 
      ? requiredPermissions.every(p => hasPermission(user, p))
      : hasAnyPermission(user, requiredPermissions);
    
    if (!hasAccess) {
      return <Navigate to={fallbackPath} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;